import { ExploreDropdown } from '@/components/ExploreDropdown'
import React from 'react'
import { H2, YStack } from 'tamagui'

export default function ExploreScreen() {
  return (
    <YStack flex={1} backgroundColor="$bg" padding="$4">
      <H2 mb="$4">Explore</H2>
      <ExploreDropdown />
    </YStack>
  )
}
